import api from './api';

/**
 * Organization Notifications API Service
 * Handles notifications specific to organization workspace
 */

// Get organization notifications with pagination and filters
export const getOrgNotifications = async (params = {}) => {
  const { data } = await api.get('/org/notifications', { params });
  return data;
};

// Get unread organization notification count
export const getOrgUnreadCount = async () => {
  const { data } = await api.get('/org/notifications/counts');
  return data;
};

// Mark organization notification as read
export const markOrgNotificationAsRead = async (notificationId) => {
  const { data } = await api.put(`/org/notifications/${notificationId}/read`);
  return data;
};

// Mark all organization notifications as read
export const markAllOrgNotificationsAsRead = async () => {
  const { data } = await api.put('/org/notifications/read-all');
  return data;
};

// Delete organization notification
export const deleteOrgNotification = async (notificationId) => {
  const { data } = await api.delete(`/org/notifications/${notificationId}`);
  return data;
};

// Delete all read organization notifications
export const deleteReadOrgNotifications = async () => {
  const { data } = await api.delete('/org/notifications/read');
  return data;
};

export default {
  getOrgNotifications,
  getOrgUnreadCount,
  markOrgNotificationAsRead,
  markAllOrgNotificationsAsRead,
  deleteOrgNotification,
  deleteReadOrgNotifications
};
